export const emailUnused = (email: string) : Promise<boolean> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`/accounts/sign_up/mailcheck?email=${encodeURIComponent(email)}`)
        const data = await response.json() as { success: boolean }

        resolve(data.success)
    })
}

export const currentCountry = () : string => {
    const match = location.hostname.match(/^([A-z]{2})(.+)?.readly/)
    if (match) {
        return match[1].toUpperCase() || "GB"
    } else {
        return "GB"
    }
}

export const getBaseURL = () : string => {
    return window.location.origin;
}

export const windowWidthIsMobile = () : boolean => {
    return window.innerWidth < 769
}

export const mapRange = (factor: number, fromLow: number, fromHi: number, toLow: number, toHi: number): number => {
    return ((factor - fromLow) * (toHi - toLow)) / (fromHi - fromLow) + toLow;
}

let webpCheckCache : undefined|boolean = undefined
export const supportsWebp = () : boolean => {
    return webpCheckCache = webpCheckCache !== undefined ? webpCheckCache : document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
}

export const isTouchDevice = () => (('ontouchstart' in window) || (window.navigator.maxTouchPoints > 0) || (window.navigator["msMaxTouchPoints"] > 0))

export const CSRFToken = () => {
    return (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content
}

export const AppEnv = () => {
    return (document.querySelector('body') as HTMLBodyElement).getAttribute("data-env")
}

export const IEFTLocale = (underscore: boolean = false) : string => {
    const locale = (document.querySelector('body') as HTMLBodyElement).getAttribute("data-locale")
    return underscore ? locale.replace("-", "_") : locale
}

export const validEmail = (value) => {
    const validateDomain = (domain: string) : boolean => {
        return (
            domain.length > 0 &&
            domain.length <= 253 &&
            !(/[^a-zA-Z0-9]/.test(domain.slice(-2))) && 
            !(/[^a-zA-Z0-9]/.test(domain.substr(0, 1))) && 
            !(/[^a-zA-Z0-9\.\-]/.test(domain)) &&
            domain.split('..').length === 1 &&
            domain.split('.').length > 1
        )
    }

    const validateEmailParts = (localPart: string, domain: string) : boolean => {
        if (localPart && domain) {
            if( localPart.indexOf('"') === 0 ) {
                let len = localPart.length
                localPart = localPart.replace(/\"/g, '')
                if( localPart.length !== (len-2) ) {
                    return false
                }
            }
            return (
                validateDomain(domain) &&
                localPart.indexOf('.') !== 0 &&
                localPart.substring(localPart.length-1, localPart.length) !== '.' &&
                localPart.indexOf('..') === -1 &&
                !(/[^\w\+\.\-\#\-\_\~\!\$\&\'\(\)\*\+\,\;\=\:]/.test(localPart))
            )
        } else {
            return false
        }
    }

    const [localPart, domain] = value.toLowerCase().split('@')

    return validateEmailParts(localPart, domain)
}